import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type RangeWrapperProps = {
  children: ReactNode;
};

const RangeWrapper = ({ children }: RangeWrapperProps) => {
  return (
    <Box direction="column" className={styles.wrapper}>
      {children}
    </Box>
  );
};

export default RangeWrapper;
